import "./studio-latex-preview.css";
import { latexToMathMl, splitLatexText } from "./latex-mathml";

const studioBlockSelector = ".studio-student-block";
const ignoredParents = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "CODE", "PRE"]);
let scheduled = false;

function renderTextNode(node: Text) {
  const text = node.nodeValue ?? "";
  if (!text.includes("\\[") && !text.includes("\\(")) return;
  const parent = node.parentElement;
  if (!parent || ignoredParents.has(parent.tagName) || parent.closest("[data-studio-math]")) return;
  const segments = splitLatexText(text);
  if (!segments.some((segment) => segment.type === "math")) return;

  const fragment = document.createDocumentFragment();
  for (const segment of segments) {
    if (segment.type === "text") {
      fragment.append(document.createTextNode(segment.value));
      continue;
    }
    const wrapper = document.createElement("span");
    wrapper.dataset.studioMath = "true";
    wrapper.className = segment.display ? "studio-math-display" : "studio-math-inline";
    wrapper.innerHTML = latexToMathMl(segment.value, segment.display);
    fragment.append(wrapper);
  }
  node.replaceWith(fragment);
}

function renderBlock(block: Element) {
  const walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = (node as Text).parentElement;
      if (!parent || ignoredParents.has(parent.tagName) || parent.closest("[data-studio-math]"))
        return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });
  const nodes: Text[] = [];
  while (walker.nextNode()) nodes.push(walker.currentNode as Text);
  nodes.forEach(renderTextNode);
}

function renderAll() {
  document.querySelectorAll(studioBlockSelector).forEach(renderBlock);
}

function scheduleRender() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    renderAll();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", scheduleRender, { once: true });
} else {
  scheduleRender();
}

const observer = new MutationObserver((mutations) => {
  if (
    mutations.some((mutation) =>
      [...mutation.addedNodes].some(
        (node) =>
          node.nodeType === Node.TEXT_NODE ||
          (node instanceof Element &&
            (node.matches(studioBlockSelector) || node.querySelector(studioBlockSelector))),
      ),
    )
  )
    scheduleRender();
});

observer.observe(document.documentElement, { childList: true, subtree: true });
